import { render, staticRenderFns } from "./SelfDiagnosisChartItem.vue?vue&type=template&id=6335c024&scoped=true&"
import script from "./SelfDiagnosisChartItem.vue?vue&type=script&lang=js&"
export * from "./SelfDiagnosisChartItem.vue?vue&type=script&lang=js&"
import style0 from "./SelfDiagnosisChartItem.vue?vue&type=style&index=0&id=6335c024&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6335c024",
  null
  
)

export default component.exports